import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchCoinLog,
  fetchCoinLogs,
} from "../../actions/callrecorder/coinLogsActions";

export interface CoinLogInterface {
  url: string;

  id: number;
  user_id: number;
  user_number_id: number | null;
  type_id: number;
  type_name: string | null;
  consume: boolean;
  amount: string | null;
  product_id: number | null;
  productid: string | null;
  original_transaction_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<CoinLogInterface>();

const slice = createSlice({
  name: 'coinLogs',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchCoinLogs.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchCoinLogs.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.coinLogs;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchCoinLogs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchCoinLog.fulfilled, (state, action) => {
        const record = Object.values(action.payload.coinLog)[0];
        state.entities[record.id] = record;
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectCoinLogById,
  selectIds: selectCoinLogIds,
  selectEntities: selectCoinLogEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.coinLogs);
